export class OfferSearchRequestDto {
	public from: number = 0;
	public to: number = 50;
	public calculationId: number = 0;
	public searchTerm: string = "";
}
